export default {"sports":"LkuD9","sport":"JNGeX H9fHT UzvkT","selected":"MccHT","icon":"tP0sE"};